var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{class:_vm.notification.text !== '' && 'active',attrs:{"dense":"","text":false,"shaped":true,"type":_vm.notification.status,"elevation":"4"}},[_vm._v(" "+_vm._s(_vm.notification.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }